<template>
  <v-chip
    label
    :class="{ full: full }"
    :small="mini"
    :color="color"
    :text-color="textColor"
    :to="routeName ? { name: routeName } : null"
    @click.stop
    ><strong>{{ text }}</strong>
  </v-chip>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'gray'
    },
    full: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      default: 'black'
    },
    routeName: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

p,
span {
  font-size: 12px !important;
  font-weight: bold;
  letter-spacing: 0.2px;
}

.full {
  width: 100% !important;
  justify-content: center !important;
}

@media only screen and (min-width: 600px) {
  p,
  span {
    font-size: 14px !important;
  }
}
</style>
